import {
  Autocomplete,
  Box,
  Chip,
  TextField,
  Typography,
} from '@mui/material';
import { defaultLang } from '@/utils/defaultLang';
import { LANGUAGES } from './languages';
import type { WizardData } from './types';

interface Props {
  data: WizardData;
  onChange: (partial: Partial<WizardData>) => void;
}

const LANG_MAP = new Map(LANGUAGES.map((l) => [l.code, l.label]));
function langLabel(code: string) {
  return LANG_MAP.get(code) ? `${code} — ${LANG_MAP.get(code)}` : code;
}

export function Step7I18n({ data, onChange }: Props) {
  function handleChange(_: unknown, newCodes: string[]) {
    const lang_enabled = newCodes;
    // The last selected language is the default (AIE D21); the fallback is set from it.
    const lang_fallback = [defaultLang(newCodes, 'en')];
    onChange({ lang_enabled, lang_fallback });
  }

  const def = defaultLang(data.lang_enabled);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Typography variant="body2" color="text.secondary">
        Select the languages enabled for this tour operator. The last language
        in the list is the default and the fallback. English is selected by default.
      </Typography>
      <Autocomplete
        multiple
        options={LANGUAGES.map((l) => l.code)}
        value={data.lang_enabled}
        onChange={handleChange}
        getOptionLabel={langLabel}
        disableCloseOnSelect
        renderInput={(params) => (
          <TextField
            {...params}
            label="Enabled languages"
            placeholder="Search…"
            size="small"
          />
        )}
        renderTags={(value, getTagProps) =>
          value.map((code, index) => (
            <Chip
              {...getTagProps({ index })}
              key={code}
              label={langLabel(code)}
              size="small"
            />
          ))
        }
      />
      {def && (
        <Typography variant="caption" color="text.secondary">
          Default language: <strong>{langLabel(def)}</strong>
        </Typography>
      )}
    </Box>
  );
}
